import * as React from "react";
import { Subtitle2, Text, tokens } from "@fluentui/react-components";
import { makeStyles } from "@griffel/react";

const useStyles = makeStyles({
    card: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: "12px",
        boxShadow: tokens.shadow16,
        padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
});

export interface CardSectionProps {
    title?: string;
    children: React.ReactNode;
}

export const CardSection: React.FC<CardSectionProps> = ({ title, children }) => {
    const styles = useStyles();

    return (
        <div className={styles.card}>
            { !!title && <Subtitle2>{title}</Subtitle2> }
            <Text>{children}</Text>
        </div>
    );
};